export const SEARCH_MAP = {
    URI_TO_TYPE: {
        properties: 'PROPERTY',
        'shops-to-rent': 'PROPERTY',
        schemes: 'SCHEME',
        'retail-schemes': 'SCHEME',
        'leisure-schemes': 'SCHEME',
        'retail-parks': 'SCHEME',
        'shopping-centres': 'SCHEME',
        'high-street': 'SCHEME',
        'regional': 'SCHEME',
        'local': 'SCHEME',
    },
    TYPE_TO_RESULT_URI: {
        PROPERTY: 'property',
        SCHEME: 'scheme',
    },
    TYPE_TO_SEARCH_URI: {
        PROPERTY: 'shops-to-rent',
        SCHEME: 'retail-schemes',
        PORTFOLIO_PROPERTIES: 'properties',
    },
    CRITEREA: {
        location: 'LOCATION',
        LOCATION: 'location',
        name: 'NAME',
        NAME: 'name',
        new: 'NEW',
        NEW: 'new',
        portfolio: 'PORTFOLIO',
        PORTFOLIO: 'portfolio',
        company: 'COMPANY',
        COMPANY: 'company',
    },
    NEW_URI: {
        PROPERTY: 'new-shops-to-rent',
    }
}


// This is to allow us to convert from URI to code without additional computation.
export const CATEGORIES_MAP = {
    'ALL'               : 'retail-schemes',
    'retail-schemes'    : 'ALL',
    'BP'                : 'business-parks',
    'business-parks'    : 'BP',
    'HS'                : 'high-street',
    'high-street'       : 'HS',
    'IN'                : 'industrialparks',
    'industrialparks'   : 'IN',
    'LE'                : 'leisure-schemes',
    'leisure-schemes'   : 'LE',
    'LO'                : 'logistics',
    'logistics'         : 'LO',
    'OF'                : 'offices',
    'offices'           : 'OF',
    'RW'                : 'retail-parks',
    'retail-parks'      : 'RW',
    'SC'                : 'shopping-centres',
    'shopping-centres'  : 'SC',
    'SP'                : 'shopping-parks',
    'shopping-parks'    : 'SP',
    'TP'                : 'trade-parks',
    'trade-parks'       : 'TP',
    'WO'                : 'workshops',
    'workshops'         : 'WO',
    'regional'          : 'regional',
    'local'             : 'local',
    'properties'        : 'ALL',
}

export const SECTOR_REDIRECT = (sector) => {
    switch(sector) {
        case 'OFF':
            return 'https://completelyoffice.co.uk';

        case 'TRI':
            return 'https://completelyindustrial.co.uk';

        default:
            return 'https://completely.property';
    }
}


// Constant for calculation map placement
export const EARTH_RADIUS_KM = 6378;


// Regexes for window locations that can't be redirected to after user has logged in and the
// redirect we use instead.
export const LOGIN_REDIRECT_BLACKLIST = {
// export const REDIRECT_MAP_TO = {
    index: { // We can get recursion issues if we try and send the user to '/'
        match: /^\/$/,
        redirect: '/',
    },
    reset: { // Don't allow sub locations of reset as those are intended to be temporary locations
        match: /auth\/reset.*/,
        redirect: '/',
    },
    register: { // Don't allow sub locations of register as those are intended to be temporary locations
        match: /auth\/register.*/,
        redirect: '/',
    },
}

export const updatedUseClass2020 = (use_class) => {
    const legacyClasses = ['A1','A2','A3','A4','A5','B1','B2','B3','B8','C1','C2','C3','D1','D2'];
    // Only perform calcs on legacy use classes so new ones appear correctly
    if (!legacyClasses.includes(use_class)) {
        return use_class;
    }
    switch(use_class) {
        case 'A1':
            return 'E(a)';
        case 'A2':
            return 'E(c)';
        case 'A3':
            return 'E(b)';
        case 'A4':
            return 'SG';
        case 'A5':
            return 'SG';
        case 'B1':
            return 'E(g)';
        case 'D1':
            return 'E(e-f) and F1';
        case 'D2':
            return 'E(d) and F2(c-d)';
        default:
            return 'E';
    }
}

export const SECTOR_MAP = {
    CODE_TO_URL: {
        'OFF': 'https://completelyoffice.co.uk',
        'TRI': 'https://completelyindustrial.co.uk',
    }
}
